import {
  Button,
  CloseIcon,
  Flex,
  Label,
  Text,
} from "@fluentui/react-northstar";
import { List } from "antd";

export const CommentsList = ({ comments, onDeleteComment }) => {
  const getCommentTagColor = (tag) => {
    switch (tag) {
      case "Positive":
        return "#92C3530";
      case "Suggestion":
        return "#F8D34720";
      case "Issue":
        return "#E2726E20";
      case "Grammar":
        return "#8B9DC320";
      case "Structure":
        return "#6264A720";
      case "Citation":
        return "#FF8C0020";
      default:
        return "#E8E8E820";
    }
  };

  const getCommentTagTextColor = (tag) => {
    switch (tag) {
      case "Positive":
        return "#92C353";
      case "Suggestion":
        return "#F8D347";
      case "Issue":
        return "#E2726E";
      case "Grammar":
        return "#8B9DC3";
      case "Structure":
        return "#6264A7";
      case "Citation":
        return "#FF8C00";
      default:
        return "#666666";
    }
  };
  return (
    <List
      dataSource={comments}
      renderItem={(comment, index) => (
        <List.Item>
          <Flex gap="gap.small" vAlign="center" fill>
            <Label
              circular
              styles={{
                backgroundColor: getCommentTagColor(comment.tag),
                color: getCommentTagTextColor(comment.tag),
                fontSize: "12px",
                padding: "4px 8px",
              }}
              content={comment.tag}
            />
            <Text content={comment.text} style={{ flex: 1 }} />
            {onDeleteComment && (
              <Button
                icon={<CloseIcon />}
                data-cy="delete-comment-btn"
                size="small"
                text
                iconOnly
                title="Delete comment"
                onClick={() => onDeleteComment(index)}
              />
            )}
          </Flex>
        </List.Item>
      )}
    />
  );
};
